import {
    makeStyles,
} from 'app/tss'

const BORDER_WIDTH = 2

const useStyles = makeStyles()((theme) => {
    return {
        contentWrapper: {
            height: `calc(100% - ${Number(theme.shape.tabHeight) + BORDER_WIDTH}px)`,
            width: '100%',
            display: 'flex',
            flexGrow: 1,
            backgroundColor: theme.palette.secondary[50],
            borderWidth: 1,
            borderStyle: 'solid',
            borderLeftWidth: 0,
            borderColor: theme.palette.secondary[300],
            '@media print': {
                borderWidth: 0,
                backgroundColor: theme.palette.common.white,
            },
            boxSizing: 'border-box',
        },
        content: {
            height: `calc(100% - ${Number(theme.shape.tabHeight) + BORDER_WIDTH}px)`,
            padding: theme.spacing(2),
            display: 'flex',
            flexGrow: 1,
            overflow: 'auto',
            boxSizing: 'border-box',
            flexDirection: 'column',
            width: '100%',
        },
    }
})

export default useStyles
